import { css } from 'glamor';

class StyleHelper {
  /**
   * Apply the custom style to the given CSS selector
   *
   * @param {Record<string, any> | null | undefined} customProp
   * @param {string} selector CSS selector. Style is applied to this CSS selector
   * @returns {boolean} True if any style was applied
   */
  static applyCustomStyle(customProp, selector) {
    const customStyle = this.applyWhitelistToStyle(
      customProp,
      StyleHelper.whitelist,
      StyleHelper.pseudoWhitelist
    );
    if (typeof customStyle === 'object' && customStyle !== null) {
      for (const prop in customStyle) {
        if (Object.prototype.hasOwnProperty.call(customStyle, prop)) {
          // Object rules like `:hover` need to be handled separately
          if (typeof customStyle[prop] === 'object') {
            css.global(`${selector}${prop}`, customStyle[prop]);
            delete customStyle[prop];
          }
        }
      }
      css.global(selector, customStyle);
      return true;
    }
    return false;
  }

  /**
   * Remove elements from style that are not in the whitelist.
   *
   * There are two whitelists, `whitelist` and `pseudoWhitelist`
   *
   * @param {Record<string, any> | null | undefined} customProp
   * @param {string[]} whitelist Applied to fields like `backgroundColor` whose value is just a string or a number
   * @param {string[]} pseudoWhitelist Applied to fields like `:hover` whose value is a new set of styles.
   * @returns {Record<string, any> | null}
   */
  static applyWhitelistToStyle(customProp, whitelist, pseudoWhitelist = []) {
    if (typeof customProp === 'object' && customProp !== null) {
      const customStyle = Object.assign({}, customProp);
      for (const prop in customStyle) {
        if (Object.prototype.hasOwnProperty.call(customStyle, prop)) {
          if (typeof customStyle[prop] === 'object') {
            if (pseudoWhitelist.indexOf(prop) >= 0) {
              customStyle[prop] = this.applyWhitelistToStyle(customStyle[prop], whitelist, []);
            } else {
              delete customStyle[prop];
            }
          } else if (whitelist.indexOf(prop) < 0) {
            delete customStyle[prop];
          }
        }
      }
      if (Object.keys(customStyle).length === 0) {
        return null;
      }
      return customStyle;
    }
    return null;
  }
}

StyleHelper.whitelist = [
  'backgroundColor',
  'borderRadius',
  'color',
  'fontFamily',
  'fontStyle',
  'fontWeight',
  'textDecoration',
  'textShadow',
  'textTransform',
];

StyleHelper.pseudoWhitelist = [':hover', ':focused', ':disabled'];

export default StyleHelper;
